import { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { ToastProvider } from "./components/ToastContext";
import Modal from "./components/Modal";
import Routes from "./routes";
import "bootstrap/scss/bootstrap-grid.scss";
import "react-grid-layout/css/styles.css";
import "react-phone-input-2/lib/style.css";
import "./assets/scss/main.scss";
import SplashLoader from "./components/SplashLoader";

export { withToast } from "./components/ToastContext";

class App extends Component {
    constructor(props) {
        super(props);

        const hasSeenSplash =
            sessionStorage.getItem("hasSeenSplash") === "true";
        this.state = {
            isServiceWorkerUpdated:
                localStorage.getItem("isServiceWorkerUpdated") === "true",
            displayLoader: !hasSeenSplash,
        };
    }

    componentDidMount() {
        window.addEventListener("storage", this.handleStorageChange);
        this.loaderCheck();
    }

    componentDidUpdate(previousProps) {
        if (
            !previousProps.isServiceWorkerUpdated &&
            this.props.isServiceWorkerUpdated
        ) {
            localStorage.setItem("isServiceWorkerUpdated", "true");

            if (this.isAutoReloadRoute()) {
                this.activateUpdatedServiceWorker();
            } else {
                this.setState({ isServiceWorkerUpdated: true });
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("storage", this.handleStorageChange);
    }

    handleStorageChange = (event) => {
        if (event.key === "isServiceWorkerUpdated") {
            this.setState({ isServiceWorkerUpdated: event.newValue === "true" });
        }
    };

    isAutoReloadRoute = () =>
        /^\/(boater|login|password)/.test(window.location.pathname);

    activateUpdatedServiceWorker = () => {
        localStorage.removeItem("isServiceWorkerUpdated");
        this.setState({ isServiceWorkerUpdated: false });

        const registration = this.props.serviceWorkerRegistration;
        const updatedWorker = registration?.waiting ?? registration?.installing;
        if (updatedWorker) {
            updatedWorker.postMessage({ type: "SKIP_WAITING" });
        } else if (registration) {
            registration.update();
        } else {
            // Preproduction deliberately has no service worker because Firefox
            // cannot reliably combine one with HTTP Basic Auth. Force the new
            // server build to load without relying on the browser HTTP cache.
            const url = new URL(window.location.href);
            url.searchParams.set("_update", Date.now().toString());
            window.location.replace(url);
        }
    };

    loaderCheck() {
        // Create / join channel and listen to it
        const channel = new BroadcastChannel("activeSession");
        channel.addEventListener("message", (e) => {
            if (e.data === "askSessionStatus") {
                // If detect a session ping, respond
                channel.postMessage("sessionIsActive");
            } else if (e.data === "sessionIsActive") {
                // If detect response, update status
                sessionStorage.setItem("sessionIsActive", "true");
            }
        });

        // Ping the channel to see if another session exists
        channel.postMessage("askSessionStatus");

        setTimeout(() => {
            sessionStorage.setItem("sessionIsActive", "true");
        }, 3000); // Match the delay duration from SplashLoader
    }

    render() {
        const { t } = this.props;

        const isAutoReloadRoute = this.isAutoReloadRoute();

        return (
            <ToastProvider>
                <SplashLoader
                    show={this.state.displayLoader}
                    onClose={() => {
                        this.setState({ displayLoader: false });
                        sessionStorage.setItem("hasSeenSplash", "true");
                    }}
                />
                {!isAutoReloadRoute && (
                    <Modal
                        title={t("update_title")}
                        description={t("update_description")}
                        open={this.state.isServiceWorkerUpdated}
                        handle={(val) => {
                            this.setState({ isServiceWorkerUpdated: val });
                        }}
                    >
                        <div className="modal__buttons modal__buttons--center">
                            <button
                                onClick={this.activateUpdatedServiceWorker}
                                className="vnf-btn vnf-btn-secondary vnf-btn-m vnf-btn-outline vnf-btn-orange-a4"
                            >
                                {t("do_update")}
                            </button>
                        </div>
                    </Modal>
                )}
                <Routes />
            </ToastProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isServiceWorkerInitialized: state.serviceWorkerInitialized,
        isServiceWorkerUpdated: state.serviceWorkerUpdated,
        serviceWorkerRegistration: state.serviceWorkerRegistration,
    };
};

export default withTranslation()(connect(mapStateToProps)(App));
